export { default } from './IndividualLeasing';
